import { axiosAjax } from '@app/src/config/axios';

export const serviceValidationTokenEmail = {
  async getData(url: string) {
    try {
      const token = window.location.pathname.split('/').pop();
      const { data } = await axiosAjax.post(url, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return data;
    } catch(e) {
      throw e.response.data;
    }
  }
};

